import { MijnRoute } from '../../mijn-navigatie.model';

export const INSURANCES_ADDPRODUCT: MijnRoute = {
    path: 'add/:id',
    navigationEvent: 'toVerzekerenProductAddition',
    regex: /^\/verzekeren-beheren\/add\/[^/]+$/,
    webcomponent: 'mijn-verzekeren-beheer-webcomponent',
    internalPath: '/add/:id'
};
